import React from 'react';
import { Nav } from '@gjensidige/core-navigation';

import NavAnmeldSkade from './NavAnmeldSkade';

const NavDesktop = () => {
  const isMobile = React.useContext(Nav.isMobile);

  return (
    <>
      {!isMobile && (
        <Nav.Actions>
          <Nav.Cart label="Kurv" />
          <NavAnmeldSkade />
        </Nav.Actions>
      )}
    </>
  );
};

export default NavDesktop;
